module.exports = __webpack_public_path__ + "img/beach-05.f6e97cd4.jpg";